import { useCallback, useEffect, useRef, useState } from 'react'

const PENDING_TIMEOUT_MS = 35000

export const usePendingTimeout = ({
  isPending,
  onTimeout,
}: {
  isPending: boolean
  onTimeout: () => void
}) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const [pendingTimedOut, setPendingTimedOut] = useState(false)

  const clearPendingTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }, [])

  useEffect(() => {
    if (isPending) {
      setPendingTimedOut(false)
      clearPendingTimeout()
      timeoutRef.current = setTimeout(() => {
        setPendingTimedOut(true)
        onTimeout()
      }, PENDING_TIMEOUT_MS)
    } else {
      clearPendingTimeout()
      setPendingTimedOut(false)
    }

    return clearPendingTimeout
  }, [isPending, clearPendingTimeout, onTimeout])

  return { pendingTimedOut, clearPendingTimeout }
}
